import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';

export const hasModifyAccess = (accessRightName?: string | null): boolean =>
  accessRightName === ETreeNodeAccessRightNames.Modify;
